<template>
    <CardLite class="base-tile" :width="width" :height="height">
        <template v-slot:image><slot name="image"></slot></template>
        <slot></slot>
    </CardLite>
</template>

<script>
import CardLite from "@/components/Common/Card-Lite.vue";

export default {
    name: "BasicTile",
    components: {CardLite},
    props: {
        width: {
            type: Number,
            required: false
        },
        height: {
            type: Number,
            required: false
        }
    },
};
</script>